import { gql } from '@apollo/client';
import {
  ArticleSummary,
  QueryArticleSummaryIfExistsArgs,
} from '../../../__generated__/queries-web';

export const DEFAULT_SUMMARY_PROMPT_ID = '2a6abaa4-8274-4d21-ac76-e9a80f5c408f';

export const GET_ARTICLE_SUMMARY = gql`
  query GetArticleSummary($where: ArticleSummaryUniqueFilterInput!) {
    articleSummaryIfExists(where: $where) {
      id
      body
      status
      updatedAt
    }
  }
`;

export interface GetArticleSummaryQuery {
  articleSummaryIfExists: Pick<
    ArticleSummary,
    'id' | 'body' | 'status' | 'updatedAt'
  > | null;
}

export type GetArticleSummaryQueryVariables = QueryArticleSummaryIfExistsArgs;
